import { FieldPath } from 'react-hook-form';

import { parseDaysRange } from 'components/shared/DatePicker';
import { AdapterType } from 'utils/types';

import { getFormattedDaysRange } from '../functions';
import { FieldValues, TInputDayPickerProps } from '../type';

export const DefaultValuePlank = function <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ mode, field: { value } }: AdapterType<TFieldValues, TName> & TInputDayPickerProps) {
  if (!value) return null;

  if (mode === 'single') return <span>{`Day ${value}`}</span>;

  return <span>{getFormattedDaysRange(parseDaysRange(value))}</span>;
};
